import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export class GenAIError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'GenAIError';
    }
}

export function mapHttpError(httpError: HttpErrorResponse): GenAIError | HttpErrorResponse {
    const status = httpError.status;

    switch (status) {
        case HttpStatusCode.BadRequest:
            return new GenAIError('Something went wrong with the request. Please try again.');
        case HttpStatusCode.Forbidden:
            return new GenAIError(
                'Our content moderation system deemed the input inappropriate. If you believe this was a mistake, please contact support.'
            );
        case HttpStatusCode.PayloadTooLarge:
            return new GenAIError(
                'Your request was larger than 10MB. Please try with a smaller image.'
            );
        case HttpStatusCode.UnprocessableEntity:
            return new GenAIError('Your request was rejected. Please try different parameters.');
        case HttpStatusCode.TooManyRequests:
            return new GenAIError(
                'Our AI service is currently experiencing high demand. Please try again in a moment.'
            );
        case HttpStatusCode.InternalServerError:
            return new GenAIError(
                'An internal error occurred. If the problem persists, please contact support.'
            );
        default:
            return httpError;
    }
}
